import { CmsApplianceDetailsPage } from '../../models/appliance-details/cms-appliance-details-page.interface';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.mock';
import { mockCmsApplianceDetailsForm } from './cms-appliance-details-form.mock';

export const mockCmsApplianceDetailsPage: CmsApplianceDetailsPage = {
  ...mockCmsRegistrationRoot,
  ...mockCmsApplianceDetailsForm,
  ...mockCmsProtectionUpsellPanel,
  pageTitle: 'Please tell us about your appliance',
};
